module.exports = {
      id: "bread-crum-separator-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#bread-crum-separator",
      toString: function () {
        return this.url;
      }
    }